import API from "../lib/api";

export const getModules = async () => {
  try {
    const response = await API.get("acl/modules");
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
}